<!--
  `appAutoFormGroup` junto do `[formGroup]` é OBRIGATÓRIO: o `app-input` lê o grupo por esta
  diretiva. Só com `[formGroup]` os campos criam controles próprios e o formulário de fora fica
  vazio (ver `modal-vincular-empresa`).
-->
<div
  class="party-form"
  [class.party-form--single]="layout === 'single'"
  [formGroup]="form"
  appAutoFormGroup>
  <div class="party-form__field party-form__field--wide">
    <!-- Card 3848: contrato novo é só pessoa jurídica, então o tipo é só leitura. Minuta antiga de
         pessoa física continua mostrando o tipo dela. -->
    <span class="party-form__label">Tipo da parte</span>
    <span class="party-form__readonly-value">
      {{ individual() ? 'Pessoa física (CPF)' : 'Pessoa jurídica (CNPJ)' }}
    </span>
  </div>

  <div class="party-form__field party-form__field--wide">
    <app-input
      [label]="individual() ? 'Nome completo' : 'Razão social da parceira'"
      [placeholder]="individual() ? 'Ex.: Maria da Silva' : 'Ex.: Empresa Parceira Ltda.'"
      [required]="true"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyLegalName" />
  </div>

  <div class="party-form__field">
    <app-input
      label="Nome curto"
      placeholder="Como a parceira aparece no título"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyShortName" />
  </div>

  <!-- Os dois campos ficam montados e só um aparece: trocar o `mask` de um mesmo `app-input`
       não reaplica a máscara. -->
  <div class="party-form__field" [class.party-form__hidden]="individual()">
    <app-input
      label="CNPJ"
      type="useMask"
      mask="99.999.999/9999-99"
      placeholder="00.000.000/0000-00"
      [unmask]="true"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyCnpj" />
  </div>
  <div class="party-form__field" [class.party-form__hidden]="!individual()">
    <app-input
      label="CPF"
      type="useMask"
      mask="999.999.999-99"
      placeholder="000.000.000-00"
      [unmask]="true"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyCpf" />
  </div>

  <div class="party-form__field party-form__field--wide">
    <app-input
      [label]="individual() ? 'Endereço' : 'Endereço da sede'"
      placeholder="Rua, número, bairro, cidade, UF e CEP"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyAddress" />
  </div>

  <div class="party-form__field">
    <app-input
      label="Representante da parceira"
      placeholder="Nome de quem assina pela parceira"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyRepresentativeName" />
  </div>

  <div class="party-form__field">
    <app-input
      [label]="individual() ? 'E-mail' : 'E-mail do representante'"
      type="email"
      placeholder="nome@parceira.com.br"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="partyRepresentativeEmail" />
  </div>

  <div class="party-form__field">
    <app-calendar label="Data do contrato*" formControlName="contractDate" [disabled]="readonly" />
  </div>

  <div class="party-form__field party-form__field--wide party-form__section">
    <span class="party-form__section-title">Remuneração (Anexo I)</span>
    <span class="party-form__section-hint">
      Percentuais inteiros, de 0 a 100. Valor diferente do padrão pede aprovação no envio.
    </span>
  </div>

  <div class="party-form__field">
    <app-input
      label="Regra geral (%)"
      type="number"
      suffix=" %"
      [min]="0"
      [max]="100"
      [minFractionDigits]="0"
      [maxFractionDigits]="0"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="commissionGeneralRate" />
    <div class="party-form__default-row">
      <span class="party-form__default-hint"
        >Vazio = padrão {{ defaults().commissionGeneralRate }}%</span
      >
      @if (outOfDefault().commissionGeneralRate) {
        <span class="party-form__off-default">Fora do padrão</span>
      }
    </div>
  </div>

  <div class="party-form__field">
    <app-input
      label="Crédito já aprovado (%)"
      type="number"
      suffix=" %"
      [min]="0"
      [max]="100"
      [minFractionDigits]="0"
      [maxFractionDigits]="0"
      [disabled]="readonly"
      [formGroup]="form"
      controlName="commissionApprovedCreditRate" />
    <div class="party-form__default-row">
      <span class="party-form__default-hint"
        >Vazio = padrão {{ defaults().commissionApprovedCreditRate }}%</span
      >
      @if (outOfDefault().commissionApprovedCreditRate) {
        <span class="party-form__off-default">Fora do padrão</span>
      }
    </div>
  </div>

  <div class="party-form__field party-form__field--wide party-form__signatory">
    <i class="pi pi-user-edit"></i>
    <span>
      @if (legatusSignatoryName === undefined) {
        <strong>Signatário da Legatus:</strong> sai da Parametrização (Comercial › Signatários da
        Legatus no contrato de parceria) ao gerar.
      } @else if (legatusSignatoryName) {
        <strong>Signatário da Legatus:</strong> {{ legatusSignatoryName }} (definido na
        Parametrização).
      } @else {
        <strong>Signatário da Legatus:</strong> ninguém configurado na Parametrização (Comercial ›
        Signatários da Legatus no contrato de parceria). Cadastre lá e use "Preencher variáveis
        pendentes".
      }
    </span>
  </div>

  @if (invalidFields$ | async; as invalidFields) {
    @if (invalidFields.length) {
      <div class="party-form__field party-form__field--wide party-form__invalid" role="alert">
        <i class="pi pi-exclamation-circle"></i>
        <span>Para continuar, corrija: {{ invalidFields.join('; ') }}.</span>
      </div>
    }
  }
</div>
